<template>
  <div class="page-view">
    <div class="title">Welcome</div>
    <div class="desc">首页即将上线，敬请期待</div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.page-view {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
.page-view .title {
  font-size: 100px;
}
.page-view .desc {
  font-size: 15px;
}
</style>